import { IPublicPageMenu } from 'src/interfaces/PublicPage';

export type PublicPageMenuLocation = 'top' | 'footer';

export const PUBLIC_PAGE_MENU_LOCATIONS: PublicPageMenuLocation[] = ['top', 'footer'];

/** Normalize API/menu data (supports legacy showInNav before migration). */
export function normalizeMenuLocations(menu: IPublicPageMenu): PublicPageMenuLocation[] {
  if (menu.menuLocations?.length) {
    return menu.menuLocations.filter(
      (loc): loc is PublicPageMenuLocation => loc === 'top' || loc === 'footer',
    );
  }
  const legacy = menu as IPublicPageMenu & { showInNav?: boolean };
  if (legacy.showInNav === false) return [];
  return ['top'];
}

export function hasMenuLocation(
  menu: IPublicPageMenu,
  location: PublicPageMenuLocation,
): boolean {
  return normalizeMenuLocations(menu).includes(location);
}
